@let tab = activeTab();
<section class="flex min-h-0 flex-1 flex-col gap-4 pb-4">
  <header class="flex flex-col gap-1">
    <h1 class="text-lg font-semibold text-[#3d2652]">
      {{ "mobile.voiceReport.validation.title" | translate }}
    </h1>
    <p class="text-sm text-[#7a6b8a]">
      {{ "mobile.voiceReport.validation.subtitle" | translate }}
    </p>
  </header>

  <nav
    class="flex gap-1 rounded-xl border border-[#ece4f3] bg-[#faf7fc] p-1"
    role="tablist"
    [attr.aria-label]="'mobile.voiceReport.validation.tabs.aria' | translate"
  >
    @for (tabItem of tabs; track tabItem.id) {
      <button
        type="button"
        role="tab"
        [attr.aria-selected]="tab === tabItem.id"
        [ngClass]="
          tab === tabItem.id
            ? 'flex min-h-[2.75rem] min-w-0 flex-1 flex-nowrap items-center justify-center gap-1 whitespace-nowrap rounded-lg bg-white px-2 py-2 text-xs font-semibold text-[#5a2f6b] shadow-sm'
            : 'flex min-h-[2.75rem] min-w-0 flex-1 flex-nowrap items-center justify-center gap-1 whitespace-nowrap rounded-lg px-2 py-2 text-xs font-medium text-[#7a6b8a]'
        "
        (click)="selectTab(tabItem.id)"
      >
        <span class="min-w-0 truncate">{{ tabItem.labelKey | translate }}</span>
        @if (tabItem.id === 'tasks') {
          @let count = tabItem.count();
          @if (count > 0) {
            <span
              class="inline-flex min-w-[1.125rem] shrink-0 items-center justify-center rounded-full px-1.5 text-[0.65rem]"
              [ngClass]="tab === tabItem.id ? 'bg-[#efe6f6] text-[#5a2f6b]' : 'bg-white text-[#7a6b8a]'"
            >
              {{ count }}
            </span>
          }
        }
      </button>
    }
  </nav>

  <div class="min-h-0 flex-1 overflow-y-auto" role="tabpanel">
    @if (tab === "report") {
      <div class="flex flex-col gap-3">
        @if (!isEditingReport()) {
          @if (access().hasUpdateAccess) {
          <div class="flex justify-end">
            <button
              type="button"
              class="inline-flex items-center gap-1 rounded-lg border border-[#ece4f3] bg-white px-3 py-1.5 text-xs font-semibold text-[#5a2f6b]"
              (click)="startEditReport()"
            >
              <span class="material-icons text-[16px]" aria-hidden="true">edit</span>
              {{ "mobile.voiceReport.validation.report.edit" | translate }}
            </button>
          </div>
          }
          <article
            class="voice-report-html-view rounded-xl border border-[#ece4f3] bg-white px-4 py-3 text-sm text-[#3d2652]"
            [innerHTML]="safeReportHtml()"
          ></article>
        } @else {
          <mobile-rich-text-editor
            [value]="editableReportHtml()"
            (valueChange)="onReportHtmlChange($event)"
            [minHeight]="'200px'"
            [maxHeight]="'360px'"
            [ariaLabel]="'mobile.voiceReport.validation.report.editAria' | translate"
          />
          <div class="flex gap-2">
            <button
              type="button"
              class="flex-1 rounded-lg border border-[#ece4f3] px-3 py-2 text-sm font-medium text-[#5a2f6b]"
              (click)="cancelEditReport()"
            >
              {{ "common.cancel" | translate }}
            </button>
            <button
              type="button"
              class="flex-1 rounded-lg bg-[#5a2f6b] px-3 py-2 text-sm font-semibold text-white"
              (click)="saveEditReport()"
            >
              {{ "common.save" | translate }}
            </button>
          </div>
        }
      </div>
    } @else {
      <div class="flex flex-col gap-3">
        @if (access().hasUpdateAccess) {
        <button
          type="button"
          class="inline-flex items-center justify-center gap-1 rounded-lg border border-dashed border-[#c8b3e0] bg-[#faf7fc] px-3 py-2 text-sm font-semibold text-[#5a2f6b]"
          (click)="openAddTask()"
        >
          <span class="material-icons text-[18px]" aria-hidden="true">add</span>
          {{ "mobile.voiceReport.validation.tasks.add" | translate }}
        </button>
        }

        @if (showAddTask()) {
          <article class="rounded-xl border border-[#ece4f3] bg-white p-3 space-y-2">
            <label class="block text-xs font-medium text-[#7a6b8a]">
              {{ "mobile.voiceReport.validation.tasks.labelField" | translate }}
            </label>
            <input
              type="text"
              class="w-full rounded-lg border border-[#ece4f3] px-3 py-2 text-sm"
              [value]="newTaskLabel()"
              (input)="newTaskLabel.set($any($event.target).value)"
            />
            <label class="block text-xs font-medium text-[#7a6b8a]">
              {{ "mobile.voiceReport.validation.tasks.descriptionField" | translate }}
            </label>
            <textarea
              class="w-full rounded-lg border border-[#ece4f3] px-3 py-2 text-sm"
              rows="3"
              [value]="newTaskDescription()"
              (input)="newTaskDescription.set($any($event.target).value)"
            ></textarea>
            <div class="flex gap-2 pt-1">
              <button
                type="button"
                class="flex-1 rounded-lg border px-3 py-2 text-sm"
                (click)="cancelAddTask()"
              >
                {{ "common.cancel" | translate }}
              </button>
              <button
                type="button"
                class="flex-1 rounded-lg bg-[#5a2f6b] px-3 py-2 text-sm font-semibold text-white"
                (click)="confirmAddTask()"
              >
                {{ "mobile.voiceReport.validation.tasks.confirmAdd" | translate }}
              </button>
            </div>
          </article>
        }

        @if (taskItems().length === 0) {
          <p class="rounded-xl border border-dashed border-[#ece4f3] bg-[#faf7fc] px-3 py-6 text-center text-sm text-[#7a6b8a]">
            {{ "mobile.voiceReport.validation.tasks.empty" | translate }}
          </p>
        } @else {
          <ul class="flex flex-col gap-2" role="list">
            @for (task of taskItems(); track trackTask($index, task)) {
              <li
                class="rounded-xl border border-[#ece4f3] bg-white px-3 py-3 shadow-sm"
              >
                <div class="flex items-start justify-between gap-2">
                  <div class="min-w-0 flex-1">
                    <p class="text-sm font-semibold text-[#3d2652]">{{ task.Label }}</p>
                    @if (task.Description) {
                      <p class="mt-1 text-xs leading-relaxed text-[#7a6b8a]">{{ task.Description }}</p>
                    }
                  </div>
                  @if (access().hasUpdateAccess) {
                  <button
                    type="button"
                    class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-red-600 hover:bg-red-50"
                    [attr.aria-label]="'mobile.voiceReport.validation.tasks.delete' | translate"
                    (click)="removeTask($index)"
                  >
                    <span class="material-icons text-[20px]" aria-hidden="true">delete_outline</span>
                  </button>
                  }
                </div>
              </li>
            }
          </ul>
        }
      </div>
    }
  </div>

  @if (access().hasUpdateAccess) {
  <button
    type="button"
    class="mt-auto flex min-h-[3rem] w-full items-center justify-center gap-2 rounded-xl bg-[#5a2f6b] px-4 py-3 text-sm font-semibold text-white disabled:opacity-60"
    [disabled]="isSubmitting()"
    (click)="submitValidation()"
  >
    @if (isSubmitting()) {
      <span class="material-icons animate-spin text-[20px]" aria-hidden="true">progress_activity</span>
    }
    {{ "mobile.voiceReport.validation.submit" | translate }}
  </button>
  }
</section>
